import Error from '../model/Error';
import Language from '../dto/Language';
import axios from 'axios';

export default class LanguagesRepository {
    static findAll() {
        return new Promise((resolve, reject) => {
            axios
                .get('/languages')
                .then((response) => resolve(response.data.data.map((data) => Language.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
